import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=72460044"
import script from "./AppTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports